import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {getSubmit, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {NOTIFICATIONS_TYPE} from "../../@constants";
import {repricingAlerts, repricingFormData, repricingFormDataOriginalName, repricingFormDataID, repricingActionRuleSelected} from "../../@signals";


export default function useRepricingAlerts(data={}) {
	const ruleID = data.ruleID
	const ruleName = data.name

	const { showToast } = useAppToast()
	const isLoadingAlerts = useSignal(true)
	const isLoadingItem = useSignal(false)

	useEffect(() => {
		getSubmit(`${BACKEND_APIS.REPRICING}/list`)
			.then(res => repricingAlerts.value = res)
			.catch(() => showToast.error())
			.finally(() => isLoadingAlerts.value = false)
	}, [])

	const handleChecker = useCallback(e => {
		e.stopPropagation()
		showToast.confirm('Are you sure you want to check your prices?', {
			onSubmit: () => {
				isLoadingItem.value = true
				showToast.promise(postSubmit(`${BACKEND_APIS.REPRICING}/notifications/check-price`, {
					ruleID: ruleID
				}).finally(() => isLoadingItem.value = false), {
					pending: 'Prices are currently being verified. Please wait a moment',
					success: 'Prices have been successfully verified. You will receive notifications shortly and/or changes will be applied soon.'
				})
			}
		})
	}, [ruleID])

	const handleEdit = useCallback(() => batch(() => {
		repricingFormDataID.value = ruleID
		repricingFormData.value = data
		repricingFormDataOriginalName.value = ruleName

		const actionValue = data.actionValue
		const email = data.email ?? []
		if (actionValue && email.length)
			repricingActionRuleSelected.value = NOTIFICATIONS_TYPE.REPRICING_NOTIF
		else if (!actionValue && email.length)
			repricingActionRuleSelected.value = NOTIFICATIONS_TYPE.NOTIFICATION
		else
			repricingActionRuleSelected.value = NOTIFICATIONS_TYPE.REPRICING
	}), [])

	const handleCopy = useCallback(() => repricingFormData.value = {
		...data,
		ruleID: null,
		name: `Copy of ${ruleName}`
	}, [])

	const handleDelete = useCallback(e => {
		e.stopPropagation()
		showToast.confirm(`Are you sure you want to delete rule ${ruleName}?`, {
			onSubmit: () => {
				isLoadingItem.value = true
				return postSubmit(`${BACKEND_APIS.REPRICING}/delete`, {
					ruleID: ruleID
				}).then(() => batch(() => {
					isLoadingItem.value = false
					repricingAlerts.value = [
						...repricingAlerts.value.filter(item => item.ruleID !== ruleID)
					]
				}))
			},
			onCancel: () => showToast.info('Delete process cancelled')
		})
	}, [ruleID])

	return {
		isLoadingAlerts: isLoadingAlerts.value,
		isLoadingItem: isLoadingItem.value,

		handleChecker, handleEdit, handleCopy, handleDelete
	}
}